import React, { useState } from 'react';
import { Trash2, ChevronUp, ChevronDown } from 'lucide-react';
import TransparentCard from '../TransparentCard';
import { useProductGeneral } from '../../hooks';

const ProductComparisonHeader = ({ comparison, onRemove }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const { data: general } = useProductGeneral(comparison.code);

  const displayData = general ? {
    title: general.name,
    price: general.last_price_display,
    date: general.last_price_date_display,
    changePercent: general.change_pct_value,
    changeAbsolute: general.change_abs_value,
    currency: general.currency,
  } : {
    title: comparison.name,
    price: comparison.price,
    date: '',
    changePercent: null,
    changeAbsolute: null,
    currency: '',
  };

  const changePrefix = (displayData.changePercent ?? 0) >= 0 ? '+' : '';
  const changeText = displayData.changePercent != null && displayData.changeAbsolute != null
    ? `${changePrefix}${displayData.changePercent.toFixed(2)}% / ${changePrefix}${displayData.changeAbsolute} ${displayData.currency}`
    : '';

  return (
    <TransparentCard
      className="glass-card-ui comparison-header-container"
      style={{ borderLeft: `4px solid ${comparison.color}`, overflow: 'hidden' }}
    >
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <div style={{ flex: 1 }}>
          <h2 className="chart-title" style={{ fontSize: '1.1rem' }}>{displayData.title}</h2>
        </div>
        <div className="text-end d-flex align-items-center">
          <div className="me-3">
            <h2 className="chart-price" style={{ fontSize: '1.1rem' }}>{displayData.price}</h2>
            {!isCollapsed && (
              <>
                {displayData.date && (
                  <p className="chart-price-date">{displayData.date}</p>
                )}
                {changeText && (
                  <p className="chart-price-change">{changeText}</p>
                )}
              </>
            )}
          </div>
          <div className="d-flex flex-column gap-2">
            <button
              onClick={() => setIsCollapsed(c => !c)}
              className="btn btn-sm collapse-toggle-btn"
              style={{
                background: 'rgba(116, 121, 255, 0.1)',
                border: '1px solid rgba(116, 121, 255, 0.3)',
                borderRadius: '6px',
                color: '#7479ff',
                padding: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
              }}
              title={isCollapsed ? 'Expand' : 'Collapse'}
            >
              {isCollapsed ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
            </button>
            <button
              onClick={() => onRemove(comparison.id)}
              className="btn btn-sm"
              style={{
                background: 'rgba(239, 68, 68, 0.1)',
                border: '1px solid rgba(239, 68, 68, 0.3)',
                borderRadius: '6px',
                color: '#EF4444',
                padding: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              title={`Remove ${comparison.name}`}
            >
              <Trash2 size={16} />
            </button>
          </div>
        </div>
      </div>
    </TransparentCard>
  );
};

export default ProductComparisonHeader;
